import { Link, Navigate, useParams } from "react-router-dom";
import StitchFlowLayout from "@/components/stitch/StitchFlowLayout";
import { getConsultingProgram } from "@/content/consultingPrograms";

export default function ConsultingProgramDetailPage() {
  const { programSlug } = useParams();
  const program = getConsultingProgram(programSlug);
  if (!program) return <Navigate to="/bulunamadi" replace />;

  return (
    <StitchFlowLayout title="Program" backTo="/danismanlik" backLabel="Programlara dön">
      <section className="stitch-program-detail">
        <div className="stitch-program-detail-summary">
          <h2>{program.months} Aylık Program</h2>
          <dl>
            <div>
              <dt>Program süresi</dt>
              <dd>{program.months} ay</dd>
            </div>
            <div>
              <dt>İlerleyiş</dt>
              <dd>Günlük çalışmalar ve düzenli takip</dd>
            </div>
            <div>
              <dt>Hazırlama</dt>
              <dd>Anketiniz değerlendirilir</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="stitch-program-process">
        <h3>Nasıl Çalışır?</h3>
        <ol>
          <li>
            <span>1</span>
            <strong>Anket değerlendirmesi</strong>
          </li>
          <li>
            <span>2</span>
            <strong>Çalışmanın hazırlanması</strong>
          </li>
          <li>
            <span>3</span>
            <strong>İlerleyişin takibi</strong>
          </li>
        </ol>

      </section>

      <div className="stitch-bottom-actions">
        <Link
          to={`/danismanlik/talep?program=${program.slug}`}
          className="stitch-primary-button"
        >
          Davet kodu iste
        </Link>
        <p>Pleiades Rehberlik Sistemleri</p>
      </div>
    </StitchFlowLayout>
  );
}
